export default "__VITE_ASSET__90bf36a2__"